import { FullFormState } from "../../../../Engine/Core/Store/FullFormState";
import { FullFormAction } from "../../../../Engine/Core/Store/FullFormAction";
import { CaptionsViewMode, HintsViewMode } from "../ViewModes";

export interface ViewModes {
    captions: CaptionsViewMode;
    hints: HintsViewMode;
}

export interface ViewModesAction {
    type: "UpdateViewModes";
    payload: Partial<ViewModes>;
}

export function viewModesReducer(state: FullFormState, action: FullFormAction): FullFormState {
    if (action.type === "UpdateViewModes") {
        return {
            ...state,
            viewModes: {
                ...state.viewModes,
                ...action.payload,
            },
        };
    }
    return state;
}
